const apyModes = ['1day', '7day', '30day'] as const
export type ApyModes = (typeof apyModes)[number]

export function isApyMode(value: string | undefined | null): value is ApyModes {
  if (!value) return false
  return apyModes.includes(value as ApyModes)
}
